import React from 'react'
import Sidebar from '../Components/Sidebar/Sidebar'
import CDashboard from '../Components/CMDashboard/CDashboard'

const CMain = () => {
  return (
    <>
    <Sidebar />
    <CDashboard />
    </>
  )
}

export default CMain